import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard  from './components/vx-card/VxCard.vue'
import VxList  from './components/vx-list/VxList.vue'
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon  from './components/FeatherIcon.vue'
import VxInputGroup  from './components/vx-input-group/VxInputGroup.vue'
import TextareaAutosize  from './components/TextareaAutosize'
import VxDivider from "./components/VxDivider"
import VxEmpty from "./components/VxEmpty"
import File from "./components/File"
import VsSelect from "./components/override-vuesax/vsSelect/vsSelect"
import vsTh from "./components/override-vuesax/vsTable"

Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component(TextareaAutosize.name, TextareaAutosize)
Vue.component(VxDivider.name, VxDivider)
Vue.component(VxEmpty.name, VxEmpty)
Vue.component(File.name, File)
Vue.component(VsSelect.name, VsSelect)
Vue.use(vsTh)

// VeeValidate
import ar from 'vee-validate/dist/locale/ar';
import VeeValidate, { Validator } from 'vee-validate';

Vue.use(VeeValidate);

Validator.localize('ar', ar);

// v-select component
import vSelect from 'vue-select'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: { icon: 'XIcon', svgClasses: 'w-4 h-4' }
    }),
  },
  dir: { type: String, default: "rtl" },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: { icon: 'ChevronDownIcon', svgClasses: 'w-5 h-5' }
    }),
  },
});

Vue.component('v-select' ,vSelect)
